'use client';

import CartDrawer from '@/components/store/cart-drawer';
import { useCartStore } from '@/lib/store/cart-store';

/**
 * Single cart drawer for all /store/* routes. Opens automatically when an item is added.
 */
export default function StoreCartShell() {
  const drawerOpen = useCartStore((s) => s.drawerOpen);
  const setDrawerOpen = useCartStore((s) => s.setDrawerOpen);

  return <CartDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />;
}
